/* ==========================================================================
   The Vibe Balance — theme interactivity (vanilla JS, no framework)
   Replaces the original mockup's DCLogic state machine with real
   Shopify Ajax Cart calls + small DOM-driven components.
   ========================================================================== */
(function(){
  "use strict";

  /* ---------------------------------------------------------------------
     Cart: add / update via Shopify Ajax API
     --------------------------------------------------------------------- */
  const Cart = {
    async add(variantId, quantity, sellingPlanId){
      const body = { items: [{ id: variantId, quantity: quantity || 1 }] };
      if (sellingPlanId) body.items[0].selling_plan = sellingPlanId;
      const res = await fetch('/cart/add.js', {
        method:'POST',
        headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
        body: JSON.stringify(body)
      });
      if (!res.ok) throw new Error('cart_add_failed');
      const item = await res.json();
      await Cart.refreshCount();
      return item;
    },
    async refreshCount(){
      const res = await fetch('/cart.js');
      const cart = await res.json();
      document.querySelectorAll('[data-cart-count]').forEach(el=>{
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
      return cart;
    }
  };
  window.TVB = window.TVB || {};
  window.TVB.Cart = Cart;

  function showToast(productName){
    const toast = document.querySelector('[data-cart-toast]');
    if (!toast) return;
    toast.querySelector('[data-toast-name]').textContent = productName;
    toast.classList.add('is-visible');
    clearTimeout(showToast._t);
    showToast._t = setTimeout(()=>toast.classList.remove('is-visible'), 2800);
  }

  document.addEventListener('submit', async function(e){
    const form = e.target.closest('form[data-add-to-cart-form]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[data-add-to-cart-btn]');
    const variantId = form.querySelector('[name="id"]').value;
    const qtyInput = form.querySelector('[name="quantity"]');
    const sellingPlanInput = form.querySelector('[name="selling_plan"]:checked, input[name="selling_plan"][data-active="true"]');
    const name = form.getAttribute('data-product-name') || '';
    const handle = form.getAttribute('data-product-handle') || '';
    try{
      if (btn){ btn.disabled = true; btn.dataset.originalText = btn.dataset.originalText || btn.textContent; btn.textContent = btn.dataset.addedText || '✓'; }
      await Cart.add(variantId, qtyInput ? parseInt(qtyInput.value||'1',10) : 1, sellingPlanInput ? sellingPlanInput.value : null);
      if (!UpsellPopup.showFor(handle)) showToast(name);
      if (btn){ setTimeout(()=>{ btn.disabled = false; btn.textContent = btn.dataset.originalText; }, 1800); }
    }catch(err){
      if (btn){ btn.disabled = false; btn.textContent = btn.dataset.originalText; }
      console.error('[TVB] add to cart failed', err);
    }
  });

  /* ---------------------------------------------------------------------
     "Comprar ya": adds the current product to cart, then goes straight
     to checkout instead of just landing on /cart.
     --------------------------------------------------------------------- */
  document.addEventListener('click', async function(e){
    const btn = e.target.closest('[data-buy-now-btn]');
    if (!btn) return;
    const form = btn.closest('form[data-add-to-cart-form]');
    if (!form) return;
    const variantId = form.querySelector('[name="id"]').value;
    const qtyInput = form.querySelector('[name="quantity"]');
    btn.disabled = true;
    try{
      await Cart.add(variantId, qtyInput ? parseInt(qtyInput.value||'1',10) : 1);
      window.location.href = '/checkout';
    }catch(err){
      btn.disabled = false;
      console.error('[TVB] buy now failed', err);
    }
  });

  /* ---------------------------------------------------------------------
     Upsell popup: "complementa tu pedido" shown after adding a hero
     product (Almohada Cervical, Masajeador) to cart, offering related
     "lifestyle" products (AliExpress-style order-complete prompt).
     --------------------------------------------------------------------- */
  const UpsellPopup = (function(){
    const popup = document.querySelector('[data-upsell-popup]');
    const mapEl = document.querySelector('[data-upsell-map]');
    let map = {};
    try{ if (mapEl) map = JSON.parse(mapEl.textContent); }catch(err){ console.error('[TVB] upsell map parse failed', err); }

    function itemMarkup(item){
      const wrap = document.createElement('div');
      wrap.style.cssText = 'display:flex;align-items:center;gap:12px;border:1px solid #e5e7eb;border-radius:6px;padding:10px;';
      wrap.innerHTML =
        '<img src="' + item.image + '" alt="" style="width:56px;height:56px;object-fit:cover;border-radius:4px;flex-shrink:0;">' +
        '<div style="flex:1;min-width:0;">' +
          '<a href="' + item.url + '" style="font-family:\'DM Sans\',sans-serif;font-size:13px;font-weight:500;color:#0E3026;text-decoration:none;display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">' + item.title + '</a>' +
          '<div style="display:flex;align-items:baseline;gap:6px;">' +
            '<span style="font-family:\'DM Sans\',sans-serif;font-size:11px;color:#9ca3af;text-decoration:line-through;">' + item.standalonePrice + '</span>' +
            '<span style="font-family:\'Oswald\',sans-serif;font-size:14px;font-weight:700;color:#5FAE86;">' + item.bundlePrice + '</span>' +
          '</div>' +
        '</div>' +
        '<button type="button" data-upsell-add style="flex-shrink:0;background:#0E3026;color:#fff;border:none;border-radius:4px;padding:8px 14px;font-family:\'DM Sans\',sans-serif;font-size:12.5px;font-weight:500;cursor:pointer;">' + (window.TVB_STRINGS && window.TVB_STRINGS.upsellAdd || 'Agregar') + '</button>';

      const addBtn = wrap.querySelector('[data-upsell-add]');
      addBtn.addEventListener('click', async function(){
        addBtn.disabled = true;
        try{
          await Cart.add(item.variantId, 1);
          addBtn.textContent = (window.TVB_STRINGS && window.TVB_STRINGS.upsellAdded) || '✓ Agregado';
        }catch(err){
          addBtn.disabled = false;
          console.error('[TVB] upsell add failed', err);
        }
      });
      return wrap;
    }

    function showFor(handle){
      if (!popup || !handle || !map[handle] || !map[handle].length) return false;
      const itemsEl = popup.querySelector('[data-upsell-items]');
      itemsEl.innerHTML = '';
      map[handle].forEach(function(item){ itemsEl.appendChild(itemMarkup(item)); });
      popup.style.display = 'flex';
      return true;
    }
    function hide(){ if (popup) popup.style.display = 'none'; }

    if (popup){
      const closeBtn = popup.querySelector('[data-upsell-close]');
      const skipBtn = popup.querySelector('[data-upsell-skip]');
      if (closeBtn) closeBtn.addEventListener('click', hide);
      if (skipBtn) skipBtn.addEventListener('click', hide);
    }

    return { showFor: showFor, hide: hide };
  })();
  window.TVB.UpsellPopup = UpsellPopup;

  document.addEventListener('click', function(e){
    const dismiss = e.target.closest('[data-toast-dismiss]');
    if (dismiss){ dismiss.closest('[data-cart-toast]').classList.remove('is-visible'); }
  });

  Cart.refreshCount();

  /* ---------------------------------------------------------------------
     Marquee carousels: manual prev/next arrows on top of the auto-scroll.
     Clicking an arrow freezes the CSS animation and steps the track by
     one item width; the track is duplicated (two full sets) so stepping
     wraps around seamlessly at the halfway point, same as the animation.
     --------------------------------------------------------------------- */
  document.addEventListener('click', function(e){
    const btn = e.target.closest('[data-marquee-prev], [data-marquee-next]');
    if (!btn) return;
    const wrap = btn.closest('.tvb-marquee-wrap');
    const track = wrap && wrap.querySelector('.tvb-marquee-track');
    if (!track) return;

    const halfWidth = track.scrollWidth / 2;
    const firstItem = track.querySelector('.tvb-marquee-item');
    const step = firstItem ? firstItem.getBoundingClientRect().width + 20 : 290;

    let current;
    if (!track.classList.contains('is-manual')){
      // First manual click: read where the CSS auto-scroll animation actually
      // is right now (its computed transform), so switching to manual control
      // doesn't make the track jump. animation:none only takes effect once
      // is-manual is added below, so this read must happen before that.
      const computed = getComputedStyle(track).transform;
      let tx = 0;
      const match = computed && computed !== 'none' ? computed.match(/matrix\(([^)]+)\)/) : null;
      if (match){
        const parts = match[1].split(',').map(parseFloat);
        tx = parts[4] || 0;
      }
      current = tx;
      track.classList.add('is-manual');
    } else {
      current = track.dataset.offset ? parseFloat(track.dataset.offset) : 0;
    }

    let next = btn.hasAttribute('data-marquee-next') ? current - step : current + step;
    if (next <= -halfWidth) next += halfWidth;
    if (next > 0) next -= halfWidth;

    track.dataset.offset = next;
    track.style.transform = 'translateX(' + next + 'px)';
  });

  /* ---------------------------------------------------------------------
     Mobile nav toggle
     --------------------------------------------------------------------- */
  document.addEventListener('click', function(e){
    const toggle = e.target.closest('[data-mobile-nav-toggle]');
    if (!toggle) return;
    const nav = document.querySelector('[data-mobile-nav]');
    if (nav) nav.classList.toggle('is-open');
  });

  /* ---------------------------------------------------------------------
     Announcement bar rotator
     --------------------------------------------------------------------- */
  (function announcementRotator(){
    const el = document.querySelector('[data-announcement-rotator]');
    if (!el) return;
    const items = Array.from(el.querySelectorAll('[data-announcement-item]'));
    if (items.length < 2) return;
    let i = 0;
    setInterval(()=>{
      items[i].style.display = 'none';
      i = (i+1) % items.length;
      items[i].style.display = '';
    }, 4500);
  })();

  /* ---------------------------------------------------------------------
     Accordion (FAQ, "why does this happen")
     --------------------------------------------------------------------- */
  document.addEventListener('click', function(e){
    const trigger = e.target.closest('[data-accordion-trigger]');
    if (!trigger) return;
    const item = trigger.closest('[data-accordion-item]');
    const group = item.closest('[data-accordion-group]');
    const singleOpen = group && group.dataset.accordionSingle === 'true';
    if (singleOpen){
      group.querySelectorAll('[data-accordion-item]').forEach(other=>{
        if (other !== item) other.classList.remove('is-open');
      });
    }
    item.classList.toggle('is-open');
  });

  /* ---------------------------------------------------------------------
     Catalog collection-tab filter (client side show/hide)
     --------------------------------------------------------------------- */
  document.addEventListener('click', function(e){
    const tab = e.target.closest('[data-catalog-tab]');
    if (!tab) return;
    const grid = document.querySelector('[data-catalog-grid]');
    if (!grid) return;
    const slug = tab.getAttribute('data-catalog-tab');
    grid.querySelectorAll('[data-catalog-tab-group]').forEach(t=>t.classList.remove('is-active'));
    tab.classList.add('is-active');
    grid.querySelectorAll('[data-product-card]').forEach(card=>{
      const cardSlugs = (card.getAttribute('data-collections')||'').split(',');
      card.style.display = (slug === 'all' || cardSlugs.includes(slug)) ? '' : 'none';
    });
  });

  /* ---------------------------------------------------------------------
     Product gallery thumbnails + lightbox
     --------------------------------------------------------------------- */
  document.addEventListener('click', function(e){
    const thumb = e.target.closest('[data-gallery-thumb]');
    if (thumb){
      const main = document.querySelector('[data-gallery-main] img');
      if (main) main.src = thumb.getAttribute('data-full-src');
      thumb.closest('[data-gallery-thumbs]').querySelectorAll('[data-gallery-thumb]').forEach(t=>t.classList.remove('is-active'));
      thumb.classList.add('is-active');
    }
    const zoomTarget = e.target.closest('[data-lightbox-src]');
    if (zoomTarget){
      const lightbox = document.querySelector('[data-lightbox]');
      if (lightbox){
        lightbox.querySelector('img').src = zoomTarget.getAttribute('data-lightbox-src');
        lightbox.classList.add('is-visible');
      }
    }
    if (e.target.closest('[data-lightbox-close]')){
      const lightbox = document.querySelector('[data-lightbox]');
      if (lightbox) lightbox.classList.remove('is-visible');
    }
  });

  /* ---------------------------------------------------------------------
     Buy mode toggle: one-time purchase vs subscription (Selling Plans)
     --------------------------------------------------------------------- */
  document.addEventListener('click', function(e){
    const modeBtn = e.target.closest('[data-buy-mode]');
    if (!modeBtn) return;
    const wrap = modeBtn.closest('[data-buy-mode-group]');
    wrap.querySelectorAll('[data-buy-mode]').forEach(b=>b.classList.remove('is-active'));
    modeBtn.classList.add('is-active');
    const mode = modeBtn.getAttribute('data-buy-mode');
    const form = wrap.closest('form');
    const sellingPlanField = form.querySelector('[data-selling-plan-id]');
    if (sellingPlanField){
      sellingPlanField.dataset.active = (mode === 'subscribe') ? 'true' : 'false';
      sellingPlanField.disabled = (mode !== 'subscribe');
    }
  });

  /* ---------------------------------------------------------------------
     Pack / quantity selector (variant switch)
     --------------------------------------------------------------------- */
  document.addEventListener('click', function(e){
    const pack = e.target.closest('[data-pack-option]');
    if (!pack) return;
    const wrap = pack.closest('[data-pack-group]');
    wrap.querySelectorAll('[data-pack-option]').forEach(p=>p.classList.remove('is-selected'));
    pack.classList.add('is-selected');
    const form = wrap.closest('form');
    const variantInput = form.querySelector('[name="id"]');
    if (variantInput) variantInput.value = pack.getAttribute('data-variant-id');
    const qtyInput = form.querySelector('[name="quantity"]');
    if (qtyInput && pack.getAttribute('data-variant-qty')) qtyInput.value = pack.getAttribute('data-variant-qty');
  });

  /* ---------------------------------------------------------------------
     Sticky mobile buy bar — shows once main CTA scrolls out of view
     --------------------------------------------------------------------- */
  (function stickyBuy(){
    const bar = document.querySelector('[data-sticky-buy]');
    const anchor = document.querySelector('[data-sticky-buy-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver((entries)=>{
      entries.forEach(entry=>{
        bar.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { rootMargin: '-80px 0px 0px 0px' });
    io.observe(anchor);
  })();

  /* ---------------------------------------------------------------------
     Interactive quiz
     --------------------------------------------------------------------- */
  (function quiz(){
    const root = document.querySelector('[data-quiz]');
    if (!root) return;
    const steps = Array.from(root.querySelectorAll('[data-quiz-step]'));
    const state = { goal:null, age:null, duration:null };

    function show(name){
      steps.forEach(s=> s.hidden = s.getAttribute('data-quiz-step') !== name);
    }
    function setProgress(pct){
      const bar = root.querySelector('[data-quiz-progress-bar]');
      if (bar) bar.style.width = pct + '%';
      const label = root.querySelector('[data-quiz-progress-label]');
      if (label) label.textContent = label.dataset.template.replace('{n}', pct === 33 ? '1' : pct === 66 ? '2' : '3');
    }

    root.addEventListener('click', function(e){
      const start = e.target.closest('[data-quiz-start]');
      if (start){ show('q1'); setProgress(33); }

      const restart = e.target.closest('[data-quiz-restart]');
      if (restart){ state.goal = state.age = state.duration = null; show('intro'); }

      const opt = e.target.closest('[data-quiz-option]');
      if (opt){
        const q = opt.closest('[data-quiz-step]').getAttribute('data-quiz-step');
        const value = opt.getAttribute('data-quiz-option');
        if (q === 'q1'){ state.goal = value; show('q2'); setProgress(66); }
        else if (q === 'q2'){ state.age = value; show('q3'); setProgress(100); }
        else if (q === 'q3'){
          state.duration = value;
          const resultId = computeResult(state.goal, state.age, state.duration);
          revealResult(resultId);
          show('result');
        }
      }
    });

    function computeResult(goal, age, dur){
      // Ported 1:1 from the original quiz recommendation logic. Result id 5
      // ("Próstata Vital 40+") is a discreet/private-purchase product on
      // purpose — it's reachable only via this quiz or a direct link, never
      // listed in the public catalog grid or collections.
      if (goal === 'pain') return dur === 'recent' ? 2 : 1;
      if (goal === 'sleep') return 3;
      if (goal === 'energy') return (age === '45-55' || age === '55plus') ? 5 : 6;
      return (age === '45-55' || age === '55plus') ? 8 : 7;
    }

    function revealResult(resultId){
      root.querySelectorAll('[data-quiz-result-card]').forEach(card=>{
        card.hidden = card.getAttribute('data-quiz-result-card') !== String(resultId);
      });
    }
  })();

  /* ---------------------------------------------------------------------
     Antes/Después drag-to-compare slider — touch + mouse via Pointer Events
     --------------------------------------------------------------------- */
  (function compareSlider(){
    document.querySelectorAll('[data-compare-slider]').forEach(function(root){
      const handle = root.querySelector('[data-compare-handle]');
      const clip = root.querySelector('[data-compare-clip]');
      if (!handle || !clip) return;
      let dragging = false;

      function setPos(clientX){
        const rect = root.getBoundingClientRect();
        let pct = ((clientX - rect.left) / rect.width) * 100;
        pct = Math.max(0, Math.min(100, pct));
        root.style.setProperty('--pos', pct + '%');
      }

      function onMove(e){
        if (!dragging) return;
        const x = e.touches ? e.touches[0].clientX : e.clientX;
        setPos(x);
      }
      function onUp(){
        dragging = false;
        document.removeEventListener('pointermove', onMove);
        document.removeEventListener('pointerup', onUp);
        document.removeEventListener('mousemove', onMove);
        document.removeEventListener('mouseup', onUp);
        document.removeEventListener('touchmove', onMove);
        document.removeEventListener('touchend', onUp);
      }
      function onDown(e){
        dragging = true;
        root.dataset.hintPlayed = 'true'; // user is already interacting, skip the auto hint
        const x = e.touches ? e.touches[0].clientX : e.clientX;
        setPos(x);
        document.addEventListener('pointermove', onMove);
        document.addEventListener('pointerup', onUp);
        document.addEventListener('mousemove', onMove);
        document.addEventListener('mouseup', onUp);
        document.addEventListener('touchmove', onMove, { passive: true });
        document.addEventListener('touchend', onUp);
        if (e.cancelable) e.preventDefault();
      }

      root.addEventListener('pointerdown', onDown);
      root.addEventListener('mousedown', onDown);
      root.addEventListener('touchstart', onDown, { passive: true });

      // Hint sweep: once the slider scrolls into view, nudge it left-right-center
      // so it's obvious it's draggable, then hand control back to the user.
      if ('IntersectionObserver' in window){
        const io = new IntersectionObserver(function(entries){
          entries.forEach(function(entry){
            if (!entry.isIntersecting || root.dataset.hintPlayed) return;
            root.dataset.hintPlayed = 'true';
            root.classList.add('tvb-compare--animating');
            const steps = [35, 65, 50];
            let i = 0;
            (function next(){
              if (i >= steps.length) { root.classList.remove('tvb-compare--animating'); return; }
              root.style.setProperty('--pos', steps[i] + '%');
              i++;
              setTimeout(next, 550);
            })();
          });
        }, { threshold: 0.6 });
        io.observe(root);
      }
    });
  })();

})();
